import { Controller } from '@hotwired/stimulus'

// Přehled kol timeline (I-BIKES-04): a season is ~300 day columns wide, so open it scrolled to today
// (a week of context on the left of the sticky bike column).
export default class BikeTimelineController extends Controller<HTMLElement> {
  override connect(): void {
    const today = this.element.querySelector<HTMLElement>('[data-today]')
    if (!today) return

    this.element.scrollLeft = Math.max(0, today.offsetLeft - this.labelWidth() - 7 * today.offsetWidth)
  }

  private labelWidth(): number {
    return this.element.querySelector<HTMLElement>('.sticky.left-0')?.offsetWidth ?? 0
  }
}
